import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import ArrowIcon from "@/assets/icons/arrow-white.svg";

export default function TeamMembersCard({
  title,
  profile_picture,
  role,
  color,
  hoverColor,
  onClick,
  className = "",
}) {
  return (
    <div
      className={`${className} max-w-[414px] relative cursor-pointer h-max m-auto sm:m-0 flex flex-col justify-center items-center sm:items-start`}
      onClick={onClick}
    >
      <div className="max-w-[414px] sm:max-h-[607px] w-full h-full relative">
        {profile_picture ? (
          <SourceFlowImage
            src={profile_picture}
            size="414x607"
            alt={"Member"}
            // Any other props you need adding to the img tag
            className="w-full h-full object-contain transition-all group-hover/item:opacity-60"
          />
        ) : (
          <img
            src={
              profile_picture
                ? profile_picture
                : "/site-assets/placeholders/img-placeholder.jpg"
            }
            alt="Member"
            className="w-full h-full object-contain"
          />
        )}
        <div className="w-[49px] h-[49px] bg-pink hidden group-hover/item:flex justify-center items-center absolute bottom-0 right-0">
          <ArrowIcon className="fill-white" />
        </div>
      </div>
      <p
        className={`text-2xl md:text-3xl/[39px] mt-6 font-normal transition-all group-hover/item:opacity-60 ${color} ${hoverColor}`}
      >
        {title}
      </p>
      <p
        className={`text-lg md:text-xl/[26px] font-normal transition-all group-hover/item:opacity-60 ${color} ${hoverColor} text-center sm:text-start`}
      >
        {role}
      </p>
    </div>
  );
}
